import axios from "axios";
import { API_BASE } from "../../config/env";
/**APPLICATION START */
export const FETCH_TRIGERAPPLICATION_FULFILLED =
  "FETCH_TRIGERAPPLICATION_FULFILLED";
export const FETCH_TRIGERAPPLICATION_REJECTED =
  "FETCH_TRIGERAPPLICATION_REJECTED";
export const FETCH_TRIGERAPPLICATION_PENDING =
  "FETCH_TRIGERAPPLICATION_PENDING";
export const RESET_TRIGERAPPLICATION = "RESET_TRIGERAPPLICATION";

export function trigerApplication(applicationId) {
  const token = localStorage.getItem("accessToken");

  return (dispatch) => {
    dispatch({
      type: "FETCH_TRIGERAPPLICATION",
      payload: axios({
        method: "post",
        url: `${API_BASE}/api/v2/second-opinion/application-information/${applicationId}`,
        headers: {
          Authorization: "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning" : "69920"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetTrigerApplication() {
  return (dispatch) => {
    dispatch({
      type: "RESET_TRIGERAPPLICATION",
    });
  };
}
